import { message, Drawer } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../../src/assets/images/logo.png";
import {
  DeleteOutlined,
  DoubleRightOutlined,
  UserOutlined,
  CloseOutlined
} from '@ant-design/icons';
import {baseUrl} from "../../../../src/config"
export const AdminPanel = () => {
  const [path,setPath]=useState("/admin/enquiries")
   const [menuOpen, setMenuOpen] = useState(false);
   const navigate=useNavigate()
   const location=useLocation()
   console.log({location})
   const storedData = localStorage.getItem("loginData");
const loginData = JSON.parse(storedData);
useEffect(()=>{
setPath(location.pathname)
},[location.pathname])
  const handleLogout = async () => {
    // handle logout functionality here, e.g., clearing session or tokens
    try {
      const resp = await axios.post(
        `${baseUrl}account/${loginData.id}/logout`,{
          username:loginData?.username,
          authToken:loginData.authToken
        },{
            headers:{
                Authorization:`Bearer ${loginData.authToken}`
            }
        }
      );
      if(resp){
        message.success("Logged out successfully")
        navigate("/admin/login")
        localStorage.setItem("loginData","{}")
      }
    
    } catch (e) {
      console.error(e);
      message.error("Failed to logout")
    }
    console.log("Logged out");
  };

  const width = window.innerWidth;
const isMobile = width <= 600;
const isTablet = width > 600 && width <= 1000;

return (
  <div
    style={{
      minHeight: "100vh",
      width: "100%",
      background: "#fff",
      position: "relative",
    }}
  >
    {/* Hamburger Icon */}
    {!menuOpen && (
      <div
        style={{
          position: "fixed",
          top: 20,
          left: 20,
          zIndex: 1001,
          background: "#fff",
          borderRadius: "50%",
          width: 44,
          height: 44,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          cursor: "pointer",
          border: "2px solid #f7941d"
        }}
        onClick={() => setMenuOpen(true)}
      >
        <span style={{ fontSize: 28, color: "#f7941d" }}>☰</span>
      </div>
    )}

    {/* Drawer Menu */}
    <Drawer
      placement="left"
      open={menuOpen}
      onClose={() => setMenuOpen(false)}
      width={240}
      closable={true}
      closeIcon={<CloseOutlined style={{ fontSize: 22, color: "#f7941d" }} />}
    >
      <div style={{ padding: 24 }}>
        <div style={{ fontWeight: 600, marginBottom: 30, fontSize: 20 }}>
          <img src={Logo} alt="Logo" style={{ width: 120, marginBottom: 16 }} />
          <div>THY Admin</div>
        </div>
        <ul style={{
          listStyleType: "none",
          padding: 0,
          display: "flex",
          flexDirection: "column",
          gap: 24,
          margin: 0,
        }}>
          <li>
            <Link style={{ color: path === "/admin/enquiries" ? "#F7941D" : "black", fontSize: 16 }} to="/admin/enquiries" onClick={() => setMenuOpen(false)}>
              Enquiries <span><DoubleRightOutlined /></span>
            </Link>
          </li>
          <li>
            <Link style={{ color: path === "/admin/products" ? "#F7941D" : "black", fontSize: 16 }} to="/admin/products" onClick={() => setMenuOpen(false)}>
              Products <span><DoubleRightOutlined /></span>
            </Link>
          </li>
          <li>
            <Link style={{ color: path === "/admin/portfolio" ? "#F7941D" : "black", fontSize: 16 }} to="/admin/portfolio" onClick={() => setMenuOpen(false)}>
              Portfolio <span><DoubleRightOutlined /></span>
            </Link>
          </li>
          <li>
            <Link style={{ color: path === "/admin/reviews" ? "#F7941D" : "black", fontSize: 16 }} to="/admin/reviews" onClick={() => setMenuOpen(false)}>
              Reviews <span><DoubleRightOutlined /></span>
            </Link>
          </li>
        </ul>
        <button
          onClick={handleLogout}
          style={{
            width: "100%",
            padding: "10px",
            background: "#f44336",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            marginTop: "30px",
            fontSize: 16,
            borderRadius: 6,
          }}
        >
          Logout
        </button>
      </div>
    </Drawer>

    {/* Main content area */}
    <div style={{
      padding: "30px 10px 10px 10px",
      minHeight: "100vh",
      boxSizing: "border-box",
      marginLeft: 0,
      marginTop: 0,
      width: "100%",
      overflowX: "auto"
    }}>
      <Outlet />
    </div>
  </div>
);
};
